import Vue from 'vue';
import 'vant/lib/index.css';
import { 
    PasswordInput,
    NumberKeyboard, 
    Button, 
    Area, 
    DatetimePicker, 
    Tab, 
    Tabs, 
    Field, 
    Uploader, 
    List, 
    PullRefresh, 
    Lazyload,
    Loading,
    Popup, 
    Picker,
    ActionSheet, 
    Toast } from 'vant';
// import { ImagePreview } from 'vant';
const components = [
    Picker,
    Toast,
    Popup,
    PullRefresh,
    List,
    Field,
    Uploader,
    Tab,
    Tabs,
    DatetimePicker,
    Area,
    PasswordInput,
    NumberKeyboard,
    Button,
    Lazyload,
    ActionSheet,
    Loading
    // ImagePreview
];

components.forEach(component => {
    Vue.use(component);
});
